const env = process.env.NODE_ENV
// var url = 'https://equity.aojuai.com/equityfee';
var url = 'http://192.168.2.75:19091/equityfee'; 
// var url = 'https://train.aojuai.com';
// 新服务
const config = {
  development:{
    // baseURL :url//本地
    baseURL :url, //线上 
   
  },
  production:{
     baseURL :'https://equity.aojuai.com/equityfee',

  }
}
export default {  
  baseURL:config[env].baseURL,
}